module.exports = __webpack_public_path__ + "assets/img/21_801.b15807a4.jpg";